module.exports = __webpack_public_path__ + "static/img/hospital.710581e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hospital.jpg
// module id = KGl3
// module chunks = 1